import {
  LayoutDashboard, BookOpen, BarChart3, Play, TestTubeDiagonal,
  BookMarked, StickyNote, Users, GraduationCap,
} from 'lucide-react';

export const navSections = [
  {
    label: 'Trade',
    items: [
      { to: '/dashboard', icon: LayoutDashboard, label: 'Overview' },
      { to: '/journal', icon: BookOpen, label: 'Journal' },
      { to: '/reports', icon: BarChart3, label: 'Performance' },
    ],
  },
  {
    label: 'Review',
    items: [
      { to: '/replay', icon: Play, label: 'Replay' },
      { to: '/backtest', icon: TestTubeDiagonal, label: 'Backtest' },
      { to: '/playbooks', icon: BookMarked, label: 'Playbooks' },
      { to: '/notebook', icon: StickyNote, label: 'Notebook' },
    ],
  },
  {
    label: 'Learn',
    items: [
      { to: '/mentor', icon: Users, label: 'Mentor' },
      { to: '/education', icon: GraduationCap, label: 'Education' },
    ],
  },
];

/** Items shown in the mobile bottom tab bar (the rest live behind "More"). */
export const mobileTabs = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Overview' },
  { to: '/journal', icon: BookOpen, label: 'Journal' },
  { to: '/reports', icon: BarChart3, label: 'Reports' },
  { to: '/replay', icon: Play, label: 'Replay' },
];

export function initials(name?: string, email?: string) {
  const source = name?.trim() || email?.split('@')[0] || 'T';
  return source.split(/[\s._-]+/).filter(Boolean).slice(0, 2).map((s) => s[0]!.toUpperCase()).join('');
}
